import { render, staticRenderFns } from "./graph-data-switch.vue?vue&type=template&id=06c330b2"
import script from "./graph-data-switch.vue?vue&type=script&lang=js"
export * from "./graph-data-switch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports